(function () {
  'use strict';

  if (window.TruckMirrorsYMM) return;

  var STORAGE_KEY = 'truckmirrors_selected_vehicle';

  function data() {
    return window.TruckMirrorsYMMData || { products: {} };
  }

  function uniq(values) {
    return Array.from(new Set(values));
  }

  function sortModels(values) {
    return uniq(values).sort(function (a, b) {
      return a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' });
    });
  }

  function allRules() {
    var out = [];
    var products = data().products || {};
    Object.keys(products).forEach(function (handle) {
      (products[handle].rules || []).forEach(function (rule) {
        out.push({
          handle: handle,
          from: Number(rule.from),
          to: Number(rule.to),
          make: rule.make,
          model: rule.model,
          note: rule.note || ''
        });
      });
    });
    return out;
  }

  function years() {
    var set = new Set();
    allRules().forEach(function (r) {
      for (var y = r.from; y <= r.to; y++) set.add(y);
    });
    return Array.from(set).sort(function (a, b) { return b - a; });
  }

  function makesForYear(year) {
    year = Number(year);
    return uniq(allRules()
      .filter(function (r) { return year >= r.from && year <= r.to; })
      .map(function (r) { return r.make; }))
      .sort(function (a, b) { return a.localeCompare(b); });
  }

  function modelsFor(year, make) {
    year = Number(year);
    return sortModels(allRules()
      .filter(function (r) {
        return year >= r.from && year <= r.to && r.make === make;
      })
      .map(function (r) { return r.model; }));
  }

  function handlesFor(year, make, model) {
    year = Number(year);
    return uniq(allRules()
      .filter(function (r) {
        return year >= r.from && year <= r.to && r.make === make && r.model === model;
      })
      .map(function (r) { return r.handle; }));
  }

  function vehicleLabel(v) {
    if (!v) return '';
    return [v.year, v.make, v.model].join(' ');
  }

  function saveVehicle(vehicle) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(vehicle));
    } catch (e) {}
  }

  function loadVehicle() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var v = JSON.parse(raw);
      if (!v || !v.year || !v.make || !v.model) return null;
      return v;
    } catch (e) {
      return null;
    }
  }

  function clearVehicle() {
    try { localStorage.removeItem(STORAGE_KEY); } catch (e) {}
  }

  function fillSelect(select, values, placeholder, selected) {
    if (!select) return;
    select.innerHTML = '';
    var first = document.createElement('option');
    first.value = '';
    first.textContent = placeholder;
    select.appendChild(first);

    values.forEach(function (value) {
      var opt = document.createElement('option');
      opt.value = String(value);
      opt.textContent = String(value);
      if (String(value) === String(selected || '')) opt.selected = true;
      select.appendChild(opt);
    });
  }

  function initSelector(root) {
    if (!root) return;

    try {
      if (new URLSearchParams(window.location.search).get('change_vehicle') === '1') {
        clearVehicle();
      }
    } catch (e) {}

    var yearEl = root.querySelector('[data-ymm-year]');
    var makeEl = root.querySelector('[data-ymm-make]');
    var modelEl = root.querySelector('[data-ymm-model]');
    var submitEl = root.querySelector('[data-ymm-submit]');
    var clearEl = root.querySelector('[data-ymm-clear]');
    var resultUrl = root.getAttribute('data-results-url') || '/pages/ymm-results';
    var saved = loadVehicle();

    function refreshMakes(selectedMake) {
      var year = yearEl.value;
      fillSelect(makeEl, year ? makesForYear(year) : [], 'Make', selectedMake);
      makeEl.disabled = !year;
      refreshModels(saved && String(saved.year) === String(year) ? saved.model : '');
    }

    function refreshModels(selectedModel) {
      var year = yearEl.value;
      var make = makeEl.value;
      fillSelect(modelEl, year && make ? modelsFor(year, make) : [], 'Model', selectedModel);
      modelEl.disabled = !(year && make);
      updateSubmit();
    }

    function updateSubmit() {
      submitEl.disabled = !(yearEl.value && makeEl.value && modelEl.value);
    }

    fillSelect(yearEl, years(), 'Year', saved && saved.year);
    fillSelect(makeEl, [], 'Make', '');
    fillSelect(modelEl, [], 'Model', '');

    if (saved && years().indexOf(Number(saved.year)) !== -1) {
      yearEl.value = String(saved.year);
      fillSelect(makeEl, makesForYear(saved.year), 'Make', saved.make);
      makeEl.disabled = false;
      if (makesForYear(saved.year).indexOf(saved.make) !== -1) {
        makeEl.value = saved.make;
        fillSelect(modelEl, modelsFor(saved.year, saved.make), 'Model', saved.model);
        modelEl.disabled = false;
        if (modelsFor(saved.year, saved.make).indexOf(saved.model) !== -1) {
          modelEl.value = saved.model;
        }
      }
    } else {
      makeEl.disabled = true;
      modelEl.disabled = true;
    }
    updateSubmit();

    yearEl.addEventListener('change', function () {
      saved = null;
      refreshMakes('');
    });
    makeEl.addEventListener('change', function () {
      saved = null;
      refreshModels('');
    });
    modelEl.addEventListener('change', updateSubmit);

    submitEl.addEventListener('click', function (event) {
      event.preventDefault();
      if (submitEl.disabled) return;
      var v = {
        year: Number(yearEl.value),
        make: makeEl.value,
        model: modelEl.value
      };
      saveVehicle(v);
      var qs = new URLSearchParams({
        year: String(v.year),
        make: v.make,
        model: v.model
      });
      window.location.href = resultUrl + (resultUrl.indexOf('?') >= 0 ? '&' : '?') + qs.toString();
    });

    if (clearEl) {
      clearEl.addEventListener('click', function (event) {
        event.preventDefault();
        clearVehicle();
        saved = null;
        fillSelect(yearEl, years(), 'Year', '');
        fillSelect(makeEl, [], 'Make', '');
        fillSelect(modelEl, [], 'Model', '');
        makeEl.disabled = true;
        modelEl.disabled = true;
        updateSubmit();
      });
    }
  }

  function vehicleFromUrl() {
    var params = new URLSearchParams(window.location.search);
    var year = Number(params.get('year'));
    var make = params.get('make') || '';
    var model = params.get('model') || '';
    if (!year || !make || !model) return null;
    if (years().indexOf(year) === -1) return null;
    if (makesForYear(year).indexOf(make) === -1) return null;
    if (modelsFor(year, make).indexOf(model) === -1) return null;
    return { year: year, make: make, model: model };
  }

  function matchingRule(handle, vehicle) {
    if (!vehicle) return null;
    var product = (data().products || {})[handle];
    if (!product) return null;
    var year = Number(vehicle.year);
    return (product.rules || []).find(function (r) {
      return year >= Number(r.from) && year <= Number(r.to) &&
        r.make === vehicle.make && r.model === vehicle.model;
    }) || null;
  }

  function displayVehicleName(vehicle) {
    if (!vehicle) return '';
    var model = vehicle.model || '';
    if (/^Ram\b/i.test(model)) return model;
    var make = vehicle.make === 'Dodge / Ram' ? 'Ram' : (vehicle.make || '');
    return (make + ' ' + model).replace(/\s+/g, ' ').trim();
  }

  function contextualTitle(handle, fallbackTitle, vehicle) {
    var product = (data().products || {})[handle];
    var rule = matchingRule(handle, vehicle);
    if (!product || !rule) return fallbackTitle || (product && product.title) || handle;

    var source = product.title || fallbackTitle || handle;
    var manual = /\bManual Tow Mirrors\b/i.test(source);
    var lower = source.toLowerCase();
    var marker = 'tow mirrors';
    var index = lower.indexOf(marker);
    var tail = index >= 0 ? source.slice(index + marker.length) : '';
    tail = tail.replace(/^\s*[|—–-]\s*/, '').trim();

    var from = Number(rule.from);
    var to = Number(rule.to);
    var range = from === to ? String(from) : String(from) + '–' + String(to);
    var result = range + ' ' + displayVehicleName(vehicle) + ' ' + (manual ? 'Manual ' : '') + 'Tow Mirrors';
    if (tail) result += ' — ' + tail;
    return result;
  }

  window.TruckMirrorsYMM = {
    years: years,
    makesForYear: makesForYear,
    modelsFor: modelsFor,
    handlesFor: handlesFor,
    vehicleLabel: vehicleLabel,
    saveVehicle: saveVehicle,
    loadVehicle: loadVehicle,
    clearVehicle: clearVehicle,
    vehicleFromUrl: vehicleFromUrl,
    matchingRule: matchingRule,
    contextualTitle: contextualTitle,
    initSelector: initSelector,
    product: function (handle) {
      return (data().products || {})[handle] || null;
    }
  };
})();
